export const ADD_EMPLOYEES_DROPDOWN_TEST_IDS = {
  CENSUS_UPLOAD_BUTTON: 'add-employees-dropdown-census-upload-button-test-id',
  SELF_REGISTRATION_BUTTON: 'add-employees-dropdown-self-registration-button-test-id',
  SINGLE_EMPLOYEE_BUTTON: 'add-employees-dropdown-single-employee-button-test-id',
  FULL_EMPLOYEE_FORM_BUTTON: 'add-employees-dropdown-full-employee-form-button-test-id',
};

export const ADD_EMPLOYEES_TABLE_TEST_IDS = {
  TABLE: 'add-employees-table-test-id',
  TABLE_ROW: 'add-employees-table-row-test-id',
} as const;

export const ADD_ON_METHOD_FILTER_DROPDOWN_TEST_IDS = {
  DROPDOWN_OPTIONS: 'add-on-method-filter-dropdown-test-id',
};

export const EMPLOYEE_ADDED_METHOD_TAG_TEST_IDS = {
  ADD_CIRCLE: 'add-circle-test-id',
  INFO_BUTTON_FILLED: 'info-button-filled-test-id',
  ACCOUNT_CIRCLE: 'account-circle-test-id',
};
